import _PropTypes from 'prop-types';
import { Svg } from '../../../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var Descender = function Descender(_ref) {
  var hasChildren = _ref.hasChildren,
      hasDescenderByLevel = _ref.hasDescenderByLevel,
      height = _ref.height,
      isLastChild = _ref.isLastChild,
      stroke = _ref.stroke,
      width = _ref.width;
  var gap = 11;
  var initialOffset = gap / 2;
  return /*#__PURE__*/jsx(Svg, {
    "aria-hidden": true,
    "data-mntl-flip-svg": "true",
    focusable: "false",
    width: (hasDescenderByLevel.length + 1) * width - 5,
    height: height,
    style: {
      display: "block"
    },
    children: /*#__PURE__*/jsx("path", {
      fill: "none",
      stroke: stroke,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeMiterlimit: "10",
      strokeDasharray: "1,4",
      d: hasDescenderByLevel.length > 0 ? hasDescenderByLevel.map(function (hasDescender, i, col) {
        var offset = (i + 1) * width + initialOffset;

        if (col.length - 1 === i) {
          var base = "M".concat(offset, " ").concat(height / 2, "h").concat(width - gap);

          if (hasChildren) {
            base = base + "M".concat(offset + width, " ").concat(height / 2 + gap, "v").concat(height / 2);
          }

          if (isLastChild) {
            return base + "M".concat(offset, " 0v").concat(height / 2);
          }

          return base + "M".concat(offset, " 0v").concat(height);
        }

        if (hasDescender) {
          return "M".concat(offset, " 0v").concat(height);
        }
      }).join("") : ["M".concat(initialOffset, " ").concat(height / 2, "h").concat(width - gap), hasChildren ? "M".concat(initialOffset + width, " ").concat(height / 2 + gap, "v").concat(height / 2 - gap) : ""].join("")
    })
  });
};

Descender.propTypes = {
  "hasChildren": _PropTypes.bool.isRequired,
  "hasDescenderByLevel": _PropTypes.arrayOf(_PropTypes.bool).isRequired,
  "height": _PropTypes.number.isRequired,
  "isLastChild": _PropTypes.bool.isRequired,
  "stroke": _PropTypes.string.isRequired,
  "width": _PropTypes.number.isRequired
};
Descender.displayName = "Descender";

export { Descender };
